export default __webpack_public_path__ + "locales/bg/Payments.json?hash=d4ad437af298c101da5df0e9aca54312";